import { consumptionAPI } from "./clients";

/**
 *
 * @param {String} email Email of the user to be invited
 */
const sendInvite = email => {
  const endpoint = `/invite/${email}`;
  return consumptionAPI.get(endpoint);
};

const getUsers = () => {
  const endpoint = `/users`;
  return consumptionAPI.get(endpoint);
};

const getSummary = () => {
  const endpoint = `/summary`;
  return consumptionAPI.get(endpoint);
};

export { sendInvite, getUsers, getSummary };
